import React from "react";

// Decorative identity only: no readings, scores or interaction.
export default function DiagnosticSeal({ compact = false }) {
  return <div className={`diagnostic-seal ${compact ? "diagnostic-seal-compact" : ""}`} aria-hidden="true">
    <svg viewBox="0 0 420 420" fill="none" focusable="false">
      <g className="diagnostic-seal-orbits" stroke="currentColor" strokeWidth=".8">
        <circle cx="210" cy="210" r="178" strokeDasharray="1 11" />
        <circle cx="210" cy="210" r="162" />
        <circle cx="210" cy="210" r="146" strokeDasharray="72 12 3 12" />
        <path d="M210 30v34m0 292v34M30 210h34m292 0h34M84 84l24 24m204 204 24 24M84 336l24-24m204-204 24-24" />
        <path d="m210 64 126 218H84L210 64Zm0 292L84 138h252L210 356Z" opacity=".42" />
        <ellipse cx="210" cy="210" rx="114" ry="62" transform="rotate(-35 210 210)" opacity=".65" />
        <ellipse cx="210" cy="210" rx="114" ry="62" transform="rotate(35 210 210)" opacity=".65" />
      </g>
      <g className="diagnostic-seal-constellation" stroke="currentColor" strokeWidth="1">
        <path d="m103 132 63 14 44-62 48 62 70-12-30 103 24 49-86 32-77-23-68-62 12-101Z" opacity=".5" />
        {[[103,132],[166,146],[210,84],[258,146],[328,134],[298,237],[322,286],[236,318],[159,295],[91,233]].map(([cx,cy],index)=><circle key={index} cx={cx} cy={cy} r={index % 3 === 0 ? 3 : 2} fill="currentColor" />)}
      </g>
      <circle cx="210" cy="210" r="62" className="diagnostic-seal-core" />
      <circle cx="210" cy="210" r="54" stroke="currentColor" strokeWidth=".7" />
      <path d="M177 205c20-21 44-21 66 0-23 19-46 19-66 0Zm4-13c19-10 37-10 57 0m-28 25v24l-9-9m24-16c12 15-3 25-15 17" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <ellipse cx="210" cy="205" rx="8" ry="12" fill="currentColor" />
    </svg>
    {!compact && <span className="diagnostic-seal-caption">KHAOS DELTA <b>9</b></span>}
  </div>;
}
